import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';

import { PropertyService } from '../../services/property.service';
import { NavigationContextService } from '../../services/navigation-context.service';

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss']
})
export class ContactInfoComponent implements OnInit {
  property: any;
  lease: any;
  loading = true;

  constructor(
    @Optional() public dialogRef: MatDialogRef<ContactInfoComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private propertyService: PropertyService,
    private route: ActivatedRoute,
    private router: Router,
    private navContext: NavigationContextService
  ) {}

  ngOnInit() {
    if (this.data && this.data.property) {
      this.property = this.data.property;
      this.lease = this.data.lease;
      if (!this.lease && this.property) {
        this.propertyService.getActiveLease(this.property).then(l => {
          this.lease = l;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
      return;
    }

    const propertyId = this.route.snapshot.queryParamMap.get('propertyId');
    if (!propertyId) {
      this.loading = false;
      return;
    }

    this.propertyService.getPublicProperty(propertyId)
      .then(p => {
        this.property = p;
        return this.propertyService.getActiveLease(p);
      })
      .then(l => {
        this.lease = l;
      })
      .catch(() => {
        this.property = null;
        this.lease = null;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  close() {
    if (this.dialogRef) {
      this.dialogRef.close();
      return;
    }
    if (this.property && this.property.id) {
      this.navContext.goToPropertyHub(this.property.id);
      return;
    }
    this.navContext.goToDashboard();
  }
}
